module.exports = __webpack_public_path__ + "img/1440.c2ecfa20.jpg";